import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Box, Typography } from "@mui/material";

const normalizeContent = (input) => {
    if (!input) return '';
    return input
        .replace(/<br\s*\/?>/gi, '\n')     // Convert <br> to newlines
        .replace(/\r\n|\r|\n/g, '\n')      // Normalize all line endings
        .replace(/(\d+)\.(?=\S)/g, '$1. ') // Ensure space after "1." if missing
        .replace(/(?<=\d\..+)\n(?=\d+\.)/g, '\n\n'); // Add blank line between numbered items
};


const MarkdownRenderer = ({ content }) => {
    const cleanedContent = normalizeContent(content);

    return (
        <Box
            sx={{
                fontSize: "1.125rem",
                lineHeight: 1.7,
                color: "text.primary",
                fontFamily: "inherit",
                "& table": {
                    borderCollapse: "collapse",
                    width: "100%",
                    mt: 2,
                },
                "& th, & td": {
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "justify",
                },
                "& ul, & ol": {
                    paddingLeft: "20px",
                    marginBottom: "1em",
                },
                "& a": {
                    color: "primary.main",
                    textDecoration: "underline",
                    wordBreak: "break-word",           // Long links break properly
                    fontSize: "1rem",                  // Consistent font size
                    lineHeight: 1.6,                   // Added line height for spacing
                    fontWeight: 400,                   // Standard link weight
                    display: "inline",                 // Avoid Safari rendering bugs with blocky <a>
                    verticalAlign: "baseline",         // Prevent visual jumpiness in iOS
                    textAlign: "justify",                 // Ensures clean alignment in some mobile views
                    letterSpacing: "0.25px",
                },
                "& p": {
                    my: 0.5,
                    textAlign: "justify",
                }
            }}
        >
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {cleanedContent}
            </ReactMarkdown>
        </Box>
    );
};

export default MarkdownRenderer;
